(() => {
  const STORAGE_KEY = "compare-products-v1";
  const LIMIT = 3;

  const sel = {
    fab: ".js-compare-fab",
    count: ".js-compare-count",
    drawer: ".js-compare-drawer",
    list: ".js-compare-list",
    empty: ".js-compare-empty",
    close: ".js-compare-close",
    current: ".js-compare-current",
    limit: ".js-compare-limit",
    clear: ".js-compare-clear",
    now: ".js-compare-now",
    checkbox: ".js-compare-checkbox",
    overlay: ".compare-modal__overlay",
    drawerCloseBtn: ".compare-drawer__close",


    // MODAL
    modal: ".js-compare-modal",
    modalClose: ".js-compare-modal-close",
    modalGrid: ".js-compare-modal-grid",
    diffToggle: ".js-compare-diff-toggle",
    fieldsScript: ".js-compare-fields",
  };

  const safeParse = (v) => {
    try {
      return JSON.parse(v);
    } catch {
      return null;
    }
  };

  const getItems = () => safeParse(localStorage.getItem(STORAGE_KEY)) || [];
  const setItems = (items) => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

  const escapeHTML = (str) =>
    String(str || "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    }[m]));

  const setOverlayActive = (on) => {
    document.querySelectorAll(sel.overlay).forEach((el) => {
      el.classList.toggle("active", !!on);
    });
  };


  const normalizeFromCheckbox = (cb) => {
    let metafields = {};
    if (cb.dataset.compareMetafields) {
      const parsed = safeParse(cb.dataset.compareMetafields);
      if (parsed && typeof parsed === "object") metafields = parsed;
    }

    return {
      productId: String(cb.dataset.productId || ""),
      handle: String(cb.dataset.productHandle || ""),
      variantId: String(cb.dataset.variantId || ""),
      metafields,
    };
  };

  const isSelected = (items, productId) =>
    items.some((i) => i.productId === String(productId));

  const syncCheckboxes = (items) => {
    document.querySelectorAll(sel.checkbox).forEach((cb) => {
      cb.checked = isSelected(items, cb.dataset.productId);
    });
  };

  const updateFab = (count) => {
    document.querySelectorAll(sel.count).forEach((el) => (el.textContent = String(count)));
    const fab = document.querySelector(sel.fab);
    if (fab) fab.classList.toggle("is-active", count > 0); // sin hidden
  };

  // --- Drawer open/close (solo clases) ---
const openDrawer = () => {
  const drawer = document.querySelector(sel.drawer);
  if (!drawer) return;
  drawer.classList.add("is-open");
  document.documentElement.classList.add("compare-no-scroll");
  setOverlayActive(true);
};

const closeDrawer = () => {
  const drawer = document.querySelector(sel.drawer);
  if (!drawer) return;
  drawer.classList.remove("is-open");
  document.documentElement.classList.remove("compare-no-scroll");
  setOverlayActive(false);
};

  // --- Modal open/close (solo clases) ---
const openModal = () => {
  const m = document.querySelector(sel.modal);
  if (!m) return;
  m.classList.add("is-open");
  document.documentElement.classList.add("compare-no-scroll");
  setOverlayActive(true);
};

const closeModal = () => {
  const m = document.querySelector(sel.modal);
  if (!m) return;
  m.classList.remove("is-open");
  document.documentElement.classList.remove("compare-no-scroll");
  setOverlayActive(false);
};

  // --- Money ---
  const formatMoney = (cents) => {
    const drawer = document.querySelector(sel.drawer);
    const moneyFormat = drawer?.dataset.moneyFormat;
    if (window.Shopify?.formatMoney && moneyFormat) return window.Shopify.formatMoney(cents, moneyFormat);
    return `S/ ${(Number(cents) / 100).toFixed(2)}`;
  };

  // --- Fetch cache ---
  const productCache = new Map(); // handle -> product json

  async function getProductByHandle(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    const data = await res.json();
    productCache.set(handle, data);
    return data;
  }

  // --- Drawer list ---
  async function renderDrawer(items) {
    const drawer = document.querySelector(sel.drawer);
    if (!drawer) return;

    const listEl = drawer.querySelector(sel.list);
    const currentEl = drawer.querySelector(sel.current);
    const limitEl = drawer.querySelector(sel.limit);
    const nowBtn = drawer.querySelector(sel.now);

    currentEl.textContent = String(items.length);
    limitEl.textContent = String(LIMIT);

    if (items.length === 0) {
      listEl.innerHTML = "";
      drawer.classList.add("is-empty");
      if (nowBtn) nowBtn.disabled = true;
      return;
    }

    drawer.classList.remove("is-empty");
    if (nowBtn) nowBtn.disabled = false;

    const rows = await Promise.all(
      items.map(async (i) => {
        const p = await getProductByHandle(i.handle);
        if (!p) return null;

        const variant =
          (p.variants || []).find((v) => String(v.id) === String(i.variantId)) ||
          (p.variants || [])[0];

        const price = variant?.price ?? p.price;
        const compareAt = variant?.compare_at_price ?? p.compare_at_price;

        const img = p.featured_image || (p.images && p.images[0]) || "";

        return `
          <li class="compare-item">
            <img class="compare-item__img" src="${img}" alt="${escapeHTML(p.title)}" loading="lazy" width="56" height="56">
            <div class="texto-producto">
              <p class="compare-item__title">${escapeHTML(p.title)}</p>
              <div class="compare-item__price">
                <strong>${formatMoney(price)}</strong>
                ${compareAt && compareAt > price ? `<s>${formatMoney(compareAt)}</s>` : ""}
              </div>
            </div>
            <button type="button" class="compare-item__remove" aria-label="Quitar" data-compare-remove="${escapeHTML(i.productId)}">×</button>
          </li>
        `;
      })
    );

    listEl.innerHTML = rows.filter(Boolean).join("");
  }

  function emitChange(items) {
    document.dispatchEvent(new CustomEvent("compare:change", { detail: items }));
  }

  function setAll(items) {
    setItems(items);
    updateFab(items.length);
    syncCheckboxes(items);
    renderDrawer(items);
    emitChange(items);
  }

  // --- Add/remove ---
  function addFromCheckbox(cb) {
    const item = normalizeFromCheckbox(cb);
    if (!item.productId) return;

    const items = getItems();
    if (isSelected(items, item.productId)) return;

    if (items.length >= LIMIT) {
      cb.checked = false;
      alert(`Puedes comparar hasta ${LIMIT} productos.`);
      return;
    }

    items.push(item);
    setAll(items);
  }

  function removeByProductId(productId) {
    const items = getItems().filter((i) => i.productId !== String(productId));
    setAll(items);
  }

  // --- Modal helpers ---
  function getCompareFields() {
    const m = document.querySelector(sel.modal);
    const script = m?.querySelector(sel.fieldsScript);
    if (!script) return [];
    try {
      return JSON.parse(script.textContent.trim());
    } catch {
      return [];
    }
  }

  function normalizeVal(v) {
    if (v == null) return "";
    if (Array.isArray(v)) return v.join(", ");
    if (typeof v === "object") return JSON.stringify(v);
    return String(v).trim();
  }

// --- Modal render ---
async function renderModal(items) {
  const m = document.querySelector(sel.modal);
  if (!m) return;

  const grid = m.querySelector(sel.modalGrid);
  if (!grid) return;

  const fields = getCompareFields();

  // ✅ NUEVO: helpers para "vacío real"
  const isEmptyVal = (raw) => {
    const v = normalizeVal(raw);
    if (!v) return true;
    const vv = v.trim();
    return vv === "" || vv === "-" || vv === "—";
  };

  // ✅ NUEVO: solo campos donde al menos 1 producto tiene valor
  const visibleFields = fields.filter((f) => {
    return items.some((i) => !isEmptyVal(i.metafields?.[f.key]));
  });

  const cols = await Promise.all(
    items.map(async (i) => {
      const p = await getProductByHandle(i.handle);
      if (!p) return "";

      const variant =
        (p.variants || []).find((v) => String(v.id) === String(i.variantId)) ||
        (p.variants || [])[0];

      const price = variant?.price ?? p.price;
      const compareAt = variant?.compare_at_price ?? p.compare_at_price;

      const img = p.featured_image || (p.images && p.images[0]) || "";

      // ✅ CAMBIO: usar visibleFields
      const specs = visibleFields
        .map((f) => {
          const val = normalizeVal(i.metafields?.[f.key]);
          return `
            <div class="compare-spec" data-field-key="${escapeHTML(f.key)}">
              <strong>${escapeHTML(f.label)}</strong><br>
              <div class="compare-spec__value">${escapeHTML(val || "-")}</div>
            </div>
          `;
        })
        .join("");

      return `
        <div class="compare-col">
          <img src="${img}" alt="${escapeHTML(p.title)}" style="max-width:220px;height:auto;">
          <h3>${escapeHTML(p.title)}</h3>
          <div class="compare-item__price">
            <strong>${formatMoney(price)}</strong>
            ${compareAt && compareAt > price ? `<s>${formatMoney(compareAt)}</s>` : ""}
          </div>

          ${specs}

          <a class="button button--primary" href="/products/${p.handle}">Ver producto</a>
          <button type="button" class="compare-remove js-compare-remove" data-compare-remove="${escapeHTML(i.productId)}">Eliminar</button>
        </div>
      `;
    })
  );

  grid.innerHTML = cols.join("");

  // ✅ CAMBIO: marcar iguales solo para visibleFields
  visibleFields.forEach((f) => {
    const values = items.map((i) => normalizeVal(i.metafields?.[f.key]));
    const same = values.length > 1 && values.every((v) => v === values[0]);

    const keySafe = (window.CSS && CSS.escape) ? CSS.escape(f.key) : f.key.replace(/"/g, '\\"');
    m.querySelectorAll(`.compare-spec[data-field-key="${keySafe}"]`)
      .forEach((el) => el.classList.toggle("is-same", same));
  });

  const diff = m.querySelector(sel.diffToggle);
  m.classList.toggle("show-differences", !!diff?.checked);
}

  // --- Init ---
  function init() {
    const items = getItems();
    updateFab(items.length);
    syncCheckboxes(items);
    renderDrawer(items);

    // Click FAB abre drawer
    document.addEventListener("click", (e) => {
      const fab = e.target.closest(sel.fab);
      if (fab) openDrawer();
    });

// Close drawer (overlay o botón)
document.addEventListener("click", (e) => {
  if (e.target.closest(sel.close) || e.target.closest(sel.drawerCloseBtn)) closeDrawer();
});

    // Quitar uno (X) (drawer)
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-compare-remove]");
      if (!btn) return;
      removeByProductId(btn.getAttribute("data-compare-remove"));
    });

    // Eliminar todos
    document.addEventListener("click", (e) => {
      const clear = e.target.closest(sel.clear);
      if (!clear) return;
      setAll([]);
    });

    // Change checkbox
    document.addEventListener("change", (e) => {
      const cb = e.target.closest(sel.checkbox);
      if (!cb) return;

      if (cb.checked) addFromCheckbox(cb);
      else removeByProductId(cb.dataset.productId);
    });

// Comparar ahora -> cierra drawer, abre modal y render
document.addEventListener("click", async (e) => {
  const now = e.target.closest(sel.now);
  if (!now) return;

  const items = getItems();

  closeDrawer();     // <- quita is-open del drawer y desactiva overlay
  openModal();       // <- activa overlay otra vez y abre modal
  await renderModal(items);
});

    // Close modal (overlay o botón)
    document.addEventListener("click", (e) => {
      if (e.target.closest(sel.modalClose)) closeModal();
    });

    // Toggle solo diferencias
    document.addEventListener("change", async (e) => {
      const t = e.target.closest(sel.diffToggle);
      if (!t) return;
      const m = document.querySelector(sel.modal);
      if (!m) return;
      m.classList.toggle("show-differences", t.checked);
    });

    // Eliminar desde modal
    document.addEventListener("click", async (e) => {
      const btn = e.target.closest(".js-compare-remove");
      if (!btn) return;
      removeByProductId(btn.getAttribute("data-compare-remove"));
      await renderModal(getItems());
    });

    // ESC cierra (primero modal, si no drawer)
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;

      const m = document.querySelector(sel.modal);
      if (m && m.classList.contains("is-open")) {
        closeModal();
        return;
      }
      closeDrawer();
    });

    // Si Dawn reemplaza el grid por filtros AJAX, re-sincroniza checks
    const grid = document.getElementById("product-grid");
    if (grid && "MutationObserver" in window) {
      new MutationObserver(() => syncCheckboxes(getItems()))
        .observe(grid, { childList: true, subtree: true });
    }
  }

  document.addEventListener("DOMContentLoaded", init);

  // API útil
  window.Compare = {
    getItems,
    clear() { setAll([]); },
    openDrawer,
    closeDrawer,
    openModal,
    closeModal,
  };
})();
